'use client';

import {
  ChangeEvent,
  PropsWithChildren,
  useEffect,
  useId,
  useState,
} from 'react';

export type SwitchProps = PropsWithChildren<{
  checked?: boolean;
  onChange?: (checked: boolean) => MaybePromise<void>;
  required?: boolean;
  disabled?: boolean;
}>;

const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  children,
  required,
  disabled,
}) => {
  const id = useId();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(checked ?? false);

  const handleChange = async (
    event: ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    const newChecked = event.currentTarget.checked;
    setIsChecked(newChecked);
    if (onChange) {
      setIsLoading(true);
      await onChange(newChecked);
      setIsLoading(false);
    }
  };

  useEffect(() => setIsChecked(checked ?? false), [checked]);

  return (
    <div className="switch">
      <input
        type="checkbox"
        disabled={disabled || isLoading}
        role="switch"
        name={id}
        id={id}
        checked={isChecked}
        onChange={handleChange}
      />
      <label htmlFor={id}>
        {children} {required ? '*' : null}
      </label>
    </div>
  );
};

export default Switch;
